import React, { useEffect, useState } from "react";
import {
    Box,
    Dialog,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";

import CampoEdicaoInline from "./CampoEdicaoInline";
import Loading from "../../Components/Loading";
import { ButtonBase, FormSectionTitle } from "../Pedidos/styles";
import { listarClientesCanalServico } from "./integracaoApi";
import { bloqueadoPorStatus, formatarMoeda } from "./utils";

const ModalClientesRevenda = ({
    open,
    onClose,
    periodo,
    revenda,
    servico,
    somenteLeitura = false,
    onSalvarNumeroSerie
}) => {
    const [clientes, setClientes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [erro, setErro] = useState("");

    useEffect(() => {
        if (!open || !revenda || !servico) return;

        let ativo = true;
        setLoading(true);
        setErro("");
        listarClientesCanalServico(revenda.distribuidorId, servico.tipoServicoId, periodo)
            .then((itens) => ativo && setClientes(itens))
            .catch(() => ativo && setErro("Erro ao carregar os clientes da revenda."))
            .finally(() => ativo && setLoading(false));

        return () => { ativo = false; };
    }, [open, revenda, servico, periodo]);

    const bloqueado = somenteLeitura || bloqueadoPorStatus(revenda?.statusOS);

    async function salvarNumeroSerie(cliente, valor) {
        await onSalvarNumeroSerie(cliente.faturamentoId, valor);
        setClientes((atuais) => atuais.map((c) =>
            c.faturamentoId === cliente.faturamentoId ? { ...c, numeroSerie: valor } : c));
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{ sx: { backgroundColor: 'transparent', boxShadow: 'none' } }}
        >
            <Box sx={{
                backgroundColor: 'white',
                py: 3,
                px: 4,
                my: 3,
                borderRadius: '30px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                width: '100%',
                position: 'relative',
                boxShadow: '0px 0px 7px rgba(0, 0, 0, 0.25)',
            }}>
                <FormSectionTitle label={`Clientes — ${revenda?.distribuidorNome || ""} • ${servico?.tipoServicoNome || "Sem tipo de serviço"}`} />

                {loading && <Box sx={{ width: '100%', py: 3 }}><Loading /></Box>}

                {!loading && erro && (
                    <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                        {erro}
                    </Typography>
                )}

                {!loading && !erro && (
                    <TableContainer sx={{ maxHeight: 360, width: '100%', mt: 2 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Cliente</TableCell>
                                    <TableCell>NS</TableCell>
                                    <TableCell>Produto</TableCell>
                                    <TableCell>Vertical</TableCell>
                                    <TableCell align="right">Valor</TableCell>
                                    <TableCell>Obs. de Faturamento</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {clientes.map((cliente, indice) => (
                                    <TableRow key={`${cliente.clienteId}-${indice}`} hover>
                                        <TableCell>{cliente.clienteNome || "—"}</TableCell>
                                        <TableCell>
                                            <CampoEdicaoInline
                                                valor={cliente.numeroSerie}
                                                tipo="texto"
                                                permitirVazio
                                                disabled={bloqueado || !cliente.faturamentoId}
                                                ariaLabel={`NS de ${cliente.clienteNome || "cliente"}`}
                                                onSalvar={(valor) => salvarNumeroSerie(cliente, valor)}
                                            />
                                        </TableCell>
                                        <TableCell>{cliente.produto || "—"}</TableCell>
                                        <TableCell>{cliente.vertical || "—"}</TableCell>
                                        <TableCell align="right">{formatarMoeda(cliente.valorParcela)}</TableCell>
                                        <TableCell>{cliente.observacaoFaturamento || "—"}</TableCell>
                                    </TableRow>
                                ))}
                                {clientes.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center">
                                            <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                                                Nenhum cliente encontrado.
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                <Box sx={{ display: 'flex', mt: 3, width: '100%', justifyContent: 'flex-end' }}>
                    <ButtonBase variant="outlined" onClick={onClose}>
                        Fechar
                    </ButtonBase>
                </Box>
            </Box>
        </Dialog>
    );
};

export default ModalClientesRevenda;
